import {
  addMonths,
  endOfMonth,
  startOfMonth,
  setHours,
  startOfDay,
} from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { useMemo } from 'react';
import { SortDirection } from 'src/apis/api-utilities';
import {
  Granularity,
  TransactionsSortBy,
} from 'src/apis/capacity-management/types';
import { useNow } from 'src/hooks/use-now';
import { timeZone } from 'src/utils/date-time-format';
import * as pp from 'src/utils/page-params';

export function usePortfolioPageParams() {
  const now = useNow();

  const { start, end } = useMemo(() => {
    const zonedNow = utcToZonedTime(now, timeZone);

    const start = setHours(startOfMonth(zonedNow), 6);
    const end = setHours(startOfDay(endOfMonth(addMonths(zonedNow, 1))), 6);

    return {
      start: zonedTimeToUtc(start, timeZone).toISOString(),
      end: zonedTimeToUtc(end, timeZone).toISOString(),
    };
  }, [now]);

  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(10))
      .add(
        pp
          .param('runtimeIntersectionFilterStart')
          .default(start)
          .filter({ label: 'Runtime' })
      )
      .add(
        pp
          .param('runtimeIntersectionFilterEnd')
          .default(end)
          .filter({ label: 'Runtime' })
      )
      .add(
        pp
          .param('granularity')
          .default(Granularity.DAILY)
          .filter({ label: 'Time Unit' })
      )
      .add(pp.param('sortBy').default<TransactionsSortBy>('CREATED_AT'))
      .add(pp.param('sortDirection').default<SortDirection>('desc'))
  );
}

export type PageParams = ReturnType<typeof usePortfolioPageParams>;

export type PageParamsValue = PageParams['value'];
